
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const onSelect = createOnFilter(onFilter)
  const hasList = (list) => list && list.length > 0
  const { incidentDates, incidentTypes, costCentres, fmoTypes } = filters

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {hasList(incidentDates) && (
          <MuiFormSelect
            id="incidentDate"
            label="Incident Date"
            options={incidentDates}
            value={filtered.incidentDate}
            onChange={onSelect('incidentDate')}
            includeEmptyOption />
        )}
        {hasList(incidentTypes) && (
          <MuiFormSelect
            id="incidentType"
            label="Incident Type"
            options={incidentTypes}
            value={filtered.incidentType}
            onChange={onSelect('incidentType')}
            includeEmptyOption />
        )}
        {hasList(costCentres) && (
          <MuiFormSelect
            id="costCentre"
            label="Cost Centre"
            options={[{ label: 'No cost centre', value: '-' }, ...costCentres]}
            value={filtered.costCentre}
            onChange={onSelect('costCentre')}
            includeEmptyOption
            emptyOptionLabel="All cost centres" />
        )}
        {hasList(fmoTypes) && (
          <MuiFormSelect
            id="fmoType"
            label="FMO"
            options={fmoTypes}
            value={filtered.fmoType}
            onChange={onSelect('fmoType')}
            includeEmptyOption />
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
